import { ExternalLink } from "@octopusdeploy/design-system-components";
import { OverviewContainer, OverviewHighlightText } from "./CommonViews";
export const CommonLibraryStepTemplateOverview = () => {
    return (<OverviewContainer>
            <OverviewHighlightText>
                <p>
                    <ExternalLink href="CustomStepTemplates">Custom step templates</ExternalLink> are pre-configured steps that can be reused in multiple projects.
                </p>
                <p>
                    <ExternalLink href="CommunityContributedStepTemplates">Community step templates</ExternalLink> are contributed by the Octopus Community. If the Community library is disabled, visit the community library website to browse and
                    import step templates manually.
                </p>
            </OverviewHighlightText>
        </OverviewContainer>);
};
